<template>
  <div class="wrapper">
    <parallax
      class="section page-header header-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <page-header />
    </parallax>

    <div class="main main-raised" ref="page" id="agenda-page">
      <div class="section">
        <div class="md-layout">
          <div class="md-layout-item md-size-65 md-small-size-95 mx-auto">
            <h2
              class="black text-center text-primary"
              style="margin:0px 0px 30px 0px"
            >{{$t('Programme')}}</h2>

            <h4
              class="text-center regular"
              style="margin-top:30px"
              v-if="!agendaSettings.show"
            >{{agendaSettings.noAgendaText[language.code]}}</h4>

            <template v-else-if="loaded">
              <template v-if="dates.length">
                <tabs
                  :tab-active="1"
                  :tab-name="tabNames"
                  :tab-title="tabDisplayNames"
                  plain
                  color-button="primary"
                >
                  <template slot="tab-pane-1">
                    <hr class="text-primary" style="margin-top:20px !important" />
                    <panels-list-by-time :dates="dates" @selectedItem="i => selectedItem = i" />
                  </template>
                  <template slot="tab-pane-2">
                    <hr class="text-primary" style="margin-top:20px !important" />
                    <panels-list-by-thematic-path
                      :dates="dates"
                      @selectedItem="i => selectedItem = i"
                    />
                  </template>
                  <template slot="tab-pane-3" v-if="isLoggedIn">
                    <hr class="text-primary" style="margin-top:20px !important" />
                    <my-agenda />
                  </template>
                </tabs>
              </template>

              <h4
                class="text-center regular"
                style="margin-top:30px"
                v-else
              >{{agendaSettings.noAgendaText[language.code]}}</h4>
            </template>
          </div>
        </div>

        <div class="modal modal-bg" :class="{ show: selectedItem }">
          <modal v-if="selectedItem" @close="selectedItem = null">
            <template slot="header">
              <h3 class="title text-center">{{selectedItem.topic}}</h3>
              <md-button
                class="md-simple md-close md-just-icon md-round modal-default-button"
                @click="selectedItem = null"
              >
                <md-icon>clear</md-icon>
              </md-button>
            </template>

            <template slot="body">
              <div v-html="selectedItem.html" />
            </template>
          </modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";

import MyAgenda from "@/pages/authenticated/components/Landing/MyAgenda";
import PanelsListByTime from "./components/Agenda/PanelsListByTime";
import PanelsListByThematicPath from "./components/Agenda/PanelsListByThematicPath";
import { mapGetters } from "vuex";
import { Tabs, Modal } from "@/components";

import axios from "@/util/axios";
import PageHeader from "./layout/PageHeader";

export default {
  mixins: [Mixins.HeaderImage],
  components: {
    Tabs,
    Modal,
    MyAgenda,
    PanelsListByTime,
    PanelsListByThematicPath,
    PageHeader
  },
  bodyClass: "landing-page",
  data() {
    return {
      showDialog: false,
      selectedItem: null,
      loaded: false,
      image: require("@/assets/img/conference/landing-bg-fe26.jpg"),
      dates: []
    };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings",
      isLoggedIn: "user/isLoggedIn"
    }),
    tabNames(){
      return this.isLoggedIn ? 
        ['schedule', 'thematicpaths', 'my-agenda'] : 
        ['schedule', 'thematicpaths'];
    },
    tabDisplayNames(){
      return this.isLoggedIn ? 
        [this.$t('Current events'), this.$t('Thematic paths'), this.$t('My agenda')] : 
        [this.$t('Current events'), this.$t('Thematic paths')];
    }
  },
  methods: {
    async loadData() {
      if (this.agendaSettings.show) {
        let loader = this.$loading.show({ container: this.$refs.page });
        try {
          this.dates = (
            await axios.get("public/panels/dates", {
              params: {
                year: this.conference.year,
                type: this.conference.type
              }
            })
          ).data;
        } finally {
          this.loaded = true;
          loader.hide();
        }
      }
    }
  },
  watch: {
    //async conference() {
    //  await this.loadData();
    //}
  },
  async mounted() {
    await this.loadData();
  },
  beforeRouteLeave(to, from, next) {
    sessionStorage.setItem('panelsScrollY', window.scrollY);
    next();
  }
};
</script>


<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.md-has-textarea + .md-layout {
  margin-top: 15px;
}

h1.info-title {
  font-size: 5rem;
}
.info-title {
  color: white !important;
}

.info-title > hr {
  color: white;
}

.page-header .container {
  max-width: 70% !important;
}
</style>

<style lang="scss">
#agenda-page {
  .md-field.md-form-group::after,
  .md-field.md-form-group::before,
  .md-field.md-datepicker::after,
  .md-field.md-datepicker::before {
    width: 100%;
  }
  .md-field.md-form-group + .md-error {
    margin-left: 0px;
  }
}

#panelsPage .md-card-tabs .md-list .md-list-item .md-list-item-button .md-icon {
  padding: 3px 0;
}

#panelsPage .md-card-plain .md-card-content,
.md-card-plain .md-card-actions {
  padding-left: 0px;
  padding-right: 0px;
}

.md-card.md-card-tabs {
  margin-top: 10px;
}
</style>